import { FlaskConical } from "lucide-react";
import { Badge } from "./badge";
import { cn } from "@/lib/cn";

/**
 * Visual marker that the surrounding result came from a DRY RUN —
 * a preview, not a real mutation. Operators reading a "patches
 * ready" result line need to know at a glance whether real changes
 * landed or whether the run only previewed them.
 *
 * Renders next to the result content; pages anchor it inside the
 * result block so removing the badge accidentally surfaces the
 * dry-run output as if it were real.
 *
 *   {result.dryRun && <DryRunBadge />}
 */
export function DryRunBadge({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex", className)}>
      <Badge tone="info" icon={FlaskConical}>Dry run</Badge>
    </span>
  );
}
